import React from "react";

const BuildContext = React.createContext({});

export default BuildContext;
